<template>
    <az-container>
        <v-form class="az-form-content mt-0 form" lazy-validation ref="form">
            <v-container class="white pr-8" fluid>
                <v-row>
                    <v-col cols="12" md="4" lg="4" sm="12" xs="12">
                        <v-autocomplete
                            v-model="relatorio.orgao.value"
                            :items="orgaos"
                            item-text="descricao"
                            item-value="id"
                            v-validate="'required'"
                            :error-messages="errors.collect('Órgão Responsável')"
                            name="Órgão Responsável"
                            is-required
                            no-data-text="Não há orgãos com este nome"
                            placeholder="Selecione"
                            @change="informarObrigatoriedadeCampos"
                            @keyup.enter="informarObrigatoriedadeCampos">
                            <template v-slot:label>
                                {{ getNomeCamposPersonalizados('orgaoResponsavel', 'INVENTARIO') }}
                                <span class="ml-1 red--text">*</span>
                            </template>
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="4" lg="4" sm="12" xs="12">
                        <az-text-view-edit-month
                            v-model="relatorio.mesReferencia.value"
                            :date-mask="'##/####'"
                            :name="'Mês/Ano de Referência'"
                            :validate="'required'"
                            required
                            :placeholderDate="'__/____'"
                            :min-date="verificarDataDeCorteRetroativa || moment(new Date(2020, 0, 1)).format('YYYY-MM-DDTHH:mm:ssZZ')"
                            :max-date="moment(new Date()).format('YYYY-MM-DDTHH:mm:ssZZ')"
                            @input="informarObrigatoriedadeCampos">
                            <template v-slot:label>
                                {{ getNomeCamposPersonalizados('mesAnoReferencia', 'INVENTARIO') }}
                                <span class="ml-1 red--text">*</span>
                            </template>
                        </az-text-view-edit-month>
                    </v-col>
                    <v-col cols="12" md="4" lg="4" sm="12" xs="12">
                        <v-radio-group
                            v-model="relatorio.tipo.value"
                            class="az-text"
                            row
                            v-validate="'required'"
                            :error-messages="errors.collect('tipoInventario')"
                            name="tipoInventario"
                            @change="informarObrigatoriedadeCampos()">
                            <v-radio
                                mark
                                label="Sintético"
                                value="SINTETICO"/>
                            <v-radio
                                label="Analitico"
                                value="ANALITICO"/>
                            <template v-slot:label>
                                {{ getNomeCamposPersonalizados('tipo', 'INVENTARIO') }}
                                <span class="ml-1 red--text">*</span>
                            </template>
                        </v-radio-group>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" md="4" lg="4" sm="12" xs="12">
                        <v-radio-group
                            v-model="relatorio.origem"
                            name="origem"
                            class="az-text"
                            row
                            label="Origem">
                            <v-radio label="Todos" :value="'TODOS'" name="todos" @click="removerCamposProjetoFonte"/>
                            <v-radio label="Com Projeto" :value="'COM_PROJETO'" name="comProjeto"/>
                            <v-radio label="Sem Projeto" :value="'SEM_PROJETO'" name="semProjeto"
                                     @click="removerCamposProjetoFonte"/>
                        </v-radio-group>
                    </v-col>
                    <v-col v-if="exibeProjeto" cols="12" md="4" lg="4" sm="12" xs="12">
                        <v-autocomplete
                            v-model="relatorio.projeto.value"
                            :items="projetos"
                            item-text="nome"
                            item-value="id"
                            :error-messages="errors.collect('Projeto')"
                            name="Projeto"
                            no-data-text="Não há projetos com este nome"
                            placeholder="Selecione">
                            <template v-slot:label>
                                Projeto
                            </template>
                            <template
                                v-if="relatorio.projeto.value"
                                v-slot:append>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <v-btn v-on="on" icon>
                                            <v-icon small @click="removerProjeto">fas fa-times</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Remover Projeto</span>
                                </v-tooltip>
                            </template>
                        </v-autocomplete>
                    </v-col>
                    <v-col v-if="exibeProjeto" cols="12" md="4" lg="4" sm="12" xs="12">
                        <v-autocomplete
                            v-model="relatorio.fonteFinanciamento.value"
                            :items="fontesFinanciamento"
                            item-text="nome"
                            item-value="id"
                            :error-messages="errors.collect('Fonte Financiamento')"
                            name="Fonte Financiamento"
                            no-data-text="Não há fontes financiamento com este nome"
                            placeholder="Selecione">
                            <template v-slot:label>
                                Fonte Financiamento
                            </template>
                            <template
                                v-if="relatorio.fonteFinanciamento.value"
                                v-slot:append>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <v-btn v-on="on" icon>
                                            <v-icon small @click="removerFonteFinanciamento">fas fa-times</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Remover Fonte Financiamento</span>
                                </v-tooltip>
                            </template>
                        </v-autocomplete>
                    </v-col>
                </v-row>


            </v-container>
        </v-form>
        <v-divider/>

        <div class="pl-4">
            <v-row>
                <v-col cols="6" xl="1" lg="2" md="2" sm="3" xs="12">
                    <v-tooltip
                        :disabled="!desabilitarBotao"
                        max-width="250"
                        nudge-left="-10"
                        top>
                        <template v-slot:activator="{ on }">
                            <div v-on="on">
                                <v-btn :disabled="desabilitarBotao"
                                       color="primary"
                                       class="ml-1 mr-3"
                                       @click="gerarRelatorioPDF">
                                    GERAR PDF
                                </v-btn>
                            </div>
                        </template>
                        Preencha todos os campos obrigatórios para gerar o relatório
                    </v-tooltip>
                </v-col>
                <v-col cols="6" xl="1" lg="2" md="2" sm="3" xs="12">
                    <v-tooltip
                        :disabled="!desabilitarBotao"
                        max-width="250"
                        nudge-left="-10"
                        top>
                        <template v-slot:activator="{ on }">
                            <div v-on="on">
                                <v-btn :disabled="desabilitarBotao"
                                       color="primary"
                                       @click="gerarRelatorioXLS">
                                    GERAR XLS
                                </v-btn>
                            </div>
                        </template>
                        Preencha todos os campos obrigatórios para gerar o relatório
                    </v-tooltip>
                </v-col>
            </v-row>
        </div>
    </az-container>
</template>

<script>
    import _ from 'lodash'
    import {actionTypes} from '@/core/constants'
    import {createNamespacedHelpers} from 'vuex'
    import AzTextViewEditMonth from '@/views/components/AzTextViewEditMonth.vue'

    const {mapGetters} = createNamespacedHelpers('CamposPersonalizados')

    export default {
        components: {AzTextViewEditMonth},
        data() {
            return {
                orgaos: [],
                fontesFinanciamento: [],
                projetos: [],
                relatorio: this.getFiltros(),
                informadoObrigatoriedadeCampos: false
            }
        },
        computed: {
            ...mapGetters(['getNomeCamposPersonalizados']),
            desabilitarBotao() {
                return !(this.relatorio.orgao.value && this.relatorio.mesReferencia.value && this.relatorio.tipo.value)
            },
            verificarDataDeCorteRetroativa() {
                return this.$store.state.parametros.dataCorteInicioCadastroRetroativo
            },
            exibeProjeto() {
                return this.relatorio.origem === 'COM_PROJETO'
            }
        },
        async mounted() {
            this.$gtag.event('Inventarios', {method: 'Google'})
            await this.buscarDados()
        },
        methods: {
            async buscarDados() {
                this.desabilitarLoadingGlobal()
                await this.buscarOrgaos()
                await this.buscarFontesFinanciamento()
                await this.buscarProjetos()
                this.habilitarLoadingGlobal()
            },
            async buscarOrgaos() {
                const resultado = await this.$store.dispatch(actionTypes.COMUM.BUSCAR_ORGAOS)
                this.orgaos = resultado.items
            },
            async buscarFontesFinanciamento() {
                const filtro = this.criarFiltroBuscaFontesFinanciamento({situacao: null})
                const resultado = await this.$store.dispatch(actionTypes.FONTE_FINANCIAMENTO.BUSCAR_FONTES_FINANCIAMENTO, filtro)
                this.fontesFinanciamento = resultado.items
            },
            async buscarProjetos() {
                const filtro = this.criarFiltroBuscaProjetos({situacao: null})
                const resultado = await this.$store.dispatch(actionTypes.PROJETO.BUSCAR_PROJETOS, filtro)
                this.projetos = resultado.items
            },
            getFiltros() {
                return _.cloneDeep(
                    this.$store.state.relatorio.inventario.filtros
                )
            },
            async informarObrigatoriedadeCampos() {
                if (!this.informadoObrigatoriedadeCampos) {
                    await this.$validator._base.validateAll()
                    this.informadoObrigatoriedadeCampos = true
                }
            },
            async gerarRelatorioPDF() {
                if (this.relatorio.tipo.value === 'SINTETICO') {
                    this.relatorio.formato.value = 'PDF'
                    await this.$store.dispatch(actionTypes.RELATORIO.BAIXAR_RELATORIO_INVENTARIO_SINTETICO_PDF, this.relatorio)
                } else {
                    this.relatorio.formato.value = 'PDF'
                    await this.$store.dispatch(actionTypes.RELATORIO.BAIXAR_RELATORIO_INVENTARIO_ANALITICO_PDF, this.relatorio)
                }
            },
            async gerarRelatorioXLS() {
                if (this.relatorio.tipo.value === 'SINTETICO') {
                    this.relatorio.formato.value = 'XLS'
                    await this.$store.dispatch(actionTypes.RELATORIO.BAIXAR_RELATORIO_INVENTARIO_SINTETICO_XLS, this.relatorio)
                } else {
                    this.relatorio.formato.value = 'XLS'
                    await this.$store.dispatch(actionTypes.RELATORIO.BAIXAR_RELATORIO_INVENTARIO_ANALITICO_XLS, this.relatorio)
                }
            },
            removerProjeto() {
                this.relatorio.projeto.value = null
            },
            removerFonteFinanciamento() {
                this.relatorio.fonteFinanciamento.value = null
            },
            removerCamposProjetoFonte() {
                this.removerProjeto()
                this.removerFonteFinanciamento()
            }
        }
    }
</script>

<style scoped lang="stylus">
    .form
        height: 72vh

    .session-title
        font-size 15px
        font-weight bold
        color #777 !important

    .layoutTamanho
        height: 698px !important

    .v-btn--icon.v-size--default
        height: 28px
</style>
